/* label-dialogues.js  (asset) */
async function loadJson(name) {
  //  /assets/dialogues.js?v=abc  →  /assets/
  const base = import.meta.url.split('/').slice(0, -1).join('/') + '/';
  const url  = base + name;                 // /assets/selfDialogues.json
  const r    = await fetch(url);
  if (!r.ok) throw new Error(`${name}: ${r.status}`);
  return r.json();
}

let cache;

export async function getDialogues() {
  if (cache) return cache;

  const [
    selfDialogues,
    betweenDialogues,
    soloPhrases,
    clickPhrases,
    hoverPhrases
  ] = await Promise.all([
    loadJson('label-selfDialogues.json'),
    loadJson('label-betweenDialogues.json'),
    loadJson('label-soloPhrases.json'),
    loadJson('label-clickPhrases.json'),
    loadJson('label-hoverPhrases.json')
  ]);

  cache = { selfDialogues, betweenDialogues, soloPhrases, clickPhrases, hoverPhrases };
  return cache;
}
